/**
 * @surfline/web-common v11.3.3 2020-12-28
 */

import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.replace';

var slugify = function slugify(str) {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-').replace(/(-){2,}/g, '-');
};

export default slugify;
//# sourceMappingURL=slugify.js.map
